import attendanceQuery from '@/pages/attendanceStatistics/attendanceQuery.vue';
import stayOutForDaysRecord from '@/pages/attendanceStatistics/stayOutForDaysRecord.vue';
import stayOutLateForDaysRecord from '@/pages/attendanceStatistics/stayOutLateForDaysRecord.vue';
import domitoryAccessRecord from '@/pages/attendanceStatistics/domitoryAccessRecord.vue';
export default {
	path: '/kqcx',
	menuName: '考勤查询',
	children: [{
		path: 'kq',
		menuName: '考勤',
		component: attendanceQuery,
	},{
		path: 'jcss',
		menuName: '出入宿舍记录',
		component: domitoryAccessRecord,
	},{
		path: 'drwg',
		menuName: '多日未归记录',
		component: stayOutForDaysRecord,
	},{
		path: 'drlg',
		menuName: '多日晚归记录',
		component: stayOutLateForDaysRecord,
	}],
	component: (resolve) => require(['@/pages/attendanceStatistics/index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/modules/attendanceStatistics.js